module.exports = __webpack_public_path__ + "images/profile_cover.jpg";